import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { Button } from 'antd';
import { withRouter } from 'kts-platform-frame/routes';

const css = require('./index.scss');

class UIAppErrorState {
    /** 倒计时 */
    // countdown: number = 3;
}

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** APP未到的错误 */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIAppError extends UIBasic<IProps, ModulesState> {

    state = new UIAppErrorState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        this.setModulesState();
    }

    render() {
        // 判断是不是双因子未认证
        let isTwoFactorAuth = this.props.match.params.type === 'twoFactorAuth' ? true : false;
        return (
            <div className={css.container}>
                <div className={css.body} >
                    <img src={require('./img.appError.svg')} height="44" alt="" />
                    <p>抱歉，你当前没有权限访问，请联系管理员。</p>
                    {isTwoFactorAuth && <Button onClick={this.goLogin} type="primary">数字证书登录</Button>}
                    {/* <Button onClick={this.props.history.goBack} type="primary">返回</Button> */}
                </div>
            </div>
        );
    }
    // 数字证书登录
    private goLogin = () => {
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        // this.props.history.push('/login');
        window.location.href = kts.Env.instance().workingUrl('//login{env}kingxunlian.com/');
    } 
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench3/UI.AppError/index.tsx